import type { DescService } from '@bufbuild/protobuf';

export type ConnectRpcServiceDef = { Schema: DescService; Impl: any; target?: any };
